// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__r53_G","text":"styles_text__mrTym"};